import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharingdataService {
  // 1. Private Subject: Only the service can push data
  private searchResultsSource = new BehaviorSubject<any[]>([]);

  // 2. Public Observable: Components subscribe to this to get data
  currentResults$ = this.searchResultsSource.asObservable();

  constructor() {}

  // 3. Method to update the data
  updateResults(data: any[]) {
    this.searchResultsSource.next(data);
  }
}